import { AxiosInstance, CancelToken } from "axios";
import { UploadedFile } from "./UploadedFile";

export const uploadFile = async (
  axios: AxiosInstance,
  file: File,
  onUploadProgress?: (progressEvent: any) => void,
  cancelToken?: CancelToken
): Promise<UploadedFile> => {
  const form = new FormData();
  form.append("file", file, file.name || "");
  form.append("publicFile", "true");

  const response = await axios({
    method: "post",
    url: `/api/files`,
    data: form,
    cancelToken: cancelToken,
    onUploadProgress: onUploadProgress,
  });

  return response.data;
};

export const getFile = async (axios: AxiosInstance, fileId: string): Promise<File> => {
  const response = await axios({
    responseType: "blob",
    method: "get",
    url: `/api/files/${fileId}`,
  });

  return response.data;
};
